import Enumerator from '../global/Enumerator';

export const contactMaritalStatusOptions = [
  'NONE',
  'Single',
  'Married',
  'Divorced',
  'DeFacto',
  'Other'
];

export class ContactMaritalStatusOption extends Enumerator {
  static default() {
    return this.of('NONE');
  }

  static of(type?: string) {
    let realType = type;
    switch (type) {
      case '1':
        realType = 'Single';
        break;
      case '2':
        realType = 'Married';
        break;
      case '3':
        realType = 'Divorced';
        break;
      case '4':
        realType = 'DeFacto';
        break;
      case '5':
        realType = 'Other';
        break;
      default:
        break;
    }
    return this.enumValueOf(realType) || this.default();
  }
}

ContactMaritalStatusOption.initEnum({
  NONE: {
    get id() {
      return 0;
    },
    get title() {
      return 'Select';
    },
    get weight() {
      return 1;
    }
  },
  Single: {
    get id() {
      return 1;
    },
    get title() {
      return 'Single';
    },
    get weight() {
      return 2;
    }
  },
  Married: {
    get id() {
      return 2;
    },
    get title() {
      return 'Married';
    },
    get weight() {
      return 3;
    }
  },
  Divorced: {
    get id() {
      return 3;
    },
    get title() {
      return 'Divorced';
    },
    get weight() {
      return 4;
    }
  },
  DeFacto: {
    get id() {
      return 4;
    },
    get title() {
      return 'De Facto';
    },
    get weight() {
      return 5;
    }
  },
  Other: {
    get id() {
      return 5;
    },
    get title() {
      return 'Other';
    },
    get weight() {
      return 6;
    }
  }
});

export default {
  contactMaritalStatusOptions,
  ContactMaritalStatusOption
};
